import React from 'react';
import {QuerySummary as HeadlessQuerySummary} from '@coveo/headless';
import {useEffect, useState, FunctionComponent} from 'react';

interface QuerySummaryProps {
  controller: HeadlessQuerySummary;
}

export const QuerySummary: FunctionComponent<QuerySummaryProps> = (props) => {
  const {controller} = props;
  const [state, setState] = useState(controller.state);

  useEffect(() => controller.subscribe(() => setState(controller.state)), []);

  const {
    hasResults,
    hasQuery,
    hasDuration,
    firstResult,
    lastResult,
    total,
    query,
    durationInSeconds,
  } = state;

  const attributes = {
    className: 'coveo-advanced-query__query-summary',
    duration: durationInSeconds,
  };

  if ( hasResults && hasQuery ) {
    return (
      <p { ...attributes }>Showing { firstResult } - { lastResult } out of <strong>{ total }</strong> for: <em>{ query }</em></p>
    );
  }

  if ( hasResults ) {
    return (
      <p { ...attributes }>Showing { firstResult } - { lastResult } out of <strong>{ total }</strong></p>
    )
  }

  if ( hasQuery ) {
    return (
      <p { ...attributes }>No results found for: <em>{ query }</em></p>
    )
  }

  return null;
};

// usage

/**
 * ```tsx
 * const controller = buildQuerySummary(engine);
 *
 * <QuerySummary controller={controller} />;
 * ```
 */
